export function registerMlvServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  const prod = import.meta.env.PROD;
  const host = typeof location !== 'undefined' ? location.hostname : '';
  const looksDeployed = prod || host === 'lavictoria-market.com' || host.endsWith('.web.app');
  if (!looksDeployed) return;
  navigator.serviceWorker.register('/sw.js').catch((err) => {
    console.warn('[SW] registro falló:', err);
  });
}
